/**
 * HUD constants shared by the PixiHUDRenderer coordinator and the extracted
 * hud/<Name>.js element modules (Phase 3D). They live here so an element can
 * import them without importing the coordinator back — that would be a cycle.
 */
export const HEALTH_MAX = 100;
export const SHIELD_MAX = 100;

/** Health/shield bar height (drift bar stays at 10px — ~1.8× taller). */
export const HUD_BAR_HEIGHT = 18;
export const HUD_BAR_ICON_SCALE = 0.6;

/** Name label above the shield bar (independent of bar height trims). */
export const HUD_PLAYER_NAME_FONT_SIZE = 14;
